<template>
  <ValidationObserver ref="formGeneratePolicy">
    <form @submit.prevent="validateGenretForm" text="off" v-if="policy">
      <md-dialog :md-active.sync="isVisible">
        <h5 :class="'upload_error'" v-if="alert">{{ alertMessage }}</h5>

        <md-dialog-title> Generate Policy </md-dialog-title>

        <md-dialog-content>
          <div class="md-layout input-layout">
            <validated-autocomplete-input
              label="Product"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.policy"
              :options="productsData"
              :required="generateRequire"
              displaylabel="name"
              :disabled="isDisabled"
              @select="($event) => productSelect($event)"
            >
            </validated-autocomplete-input>

            <validated-autocomplete-input
              label="Vehicle Makes"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.insurance_integrity_warranties.vehicle_make"
              :options="vehicleMakes"
              displaylabel="name"
              :disabled="isDisabled"
              :required="generateRequire"
              @select="($event) => getVehicleModels($event)"
            >
            </validated-autocomplete-input>

            <validated-autocomplete-input
              label="Vehicle Models"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.insurance_integrity_warranties.vehicle_model"
              :options="vehicleModels"
              displaylabel="name"
              :disabled="isDisabled"
              :required="generateRequire"
              @select="($event) => getWarrantyTypes($event)"
            >
            </validated-autocomplete-input>

            <validated-autocomplete-input
              class="md-layout-item"
              v-model="policy.insurance_integrity_warranties.vehicle_body_type"
              @select="
                ($event) =>
                  (policy.insurance_integrity_warranties.vehicle_body_type_id =
                    $event.id)
              "
              label="Vehicle Body Type"
              displaylabel="name"
              :disabled="isDisabled"
              :options="viheclesBody"
              :required="generateRequire"
            />
          </div>
          <div class="md-layout input-layout">
            <validated-text-input
              class="md-layout-item"
              v-model="policy.insurance_integrity_warranties.vehicle_reg_no"
              label="Vehicle Reg. No"
              :disabled="isDisabled"
              type="number"
              :required="generateRequire"
            />

            <validated-date-input
              class="md-layout-item"
              v-model="
                policy.insurance_integrity_warranties.vehicle_date_manufacture
              "
              label="Vehicle Manufacture Date"
              :disabled="isDisabled"
              :required="generateRequire"
            />

            <validated-text-input
              class="md-layout-item"
              v-model="policy.insurance_integrity_warranties.vehicle_odometer"
              label="Vehicle Odometer"
              :disabled="isDisabled"
              :required="generateRequire"
            />
          </div>
          <div class="md-layout input-layout">
            <validated-autocomplete-input
              label="Warrenty Type"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.insurance_integrity_warranties.warranty_type"
              :options="warrantyTypes"
              :disabled="isDisabled"
              :required="generateRequire"
              displaylabel="name"
              @select="($event) => getWarrantyOptions($event)"
            >
            </validated-autocomplete-input>
            <validated-autocomplete-input
              label="Warrenty option"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.insurance_integrity_warranties.warranty_option"
              :options="warrantyOptions"
              :disabled="isDisabled"
              displaylabel="name"
              :required="generateRequire"
              @select="($event) => getWarrantyTerms($event)"
            >
            </validated-autocomplete-input>

            <validated-autocomplete-input
              label="Cover Term"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.term"
              :disabled="isDisabled"
              :options="warrantyTerms"
              displaylabel="term"
              :required="generateRequire"
              @select="($event) => warrentyTermsSelect($event)"
            >
            </validated-autocomplete-input>

            <validated-number-input
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.premium"
              :disabled="isDisabled"
              label="Premium"
              prefix="$"
              :required="generateRequire"
            />
            <validated-number-input
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.income"
              :disabled="isDisabled"
              label="Income"
              prefix="$"
              :required="generateRequire"
            />
          </div>
          <div class="md-layout input-layout">
            <validated-date-input
              class="md-layout-item"
              :disabled="isDisabled"
              v-model="policy.policy_start_date"
              :label="'Warranty Start Date'"
              :required="generateRequire"
            />

            <validated-number-input
              class="md-layout-item"
              v-model="
                policy.insurance_integrity_warranties.warranty_amount_charged
              "
              label="Warranty Amount Charged"
              prefix="$"
              :disabled="isDisabled"
              :required="generateRequire"
            />

            <md-checkbox
              class="md-layout-item"
              v-model="
                policy.insurance_integrity_warranties
                  .is_warranty_in_vehicle_price
              "
              :disabled="isDisabled"
            >
              Is Warranty in Vehicle Price
            </md-checkbox>
          </div>
          <div class="md-layout input-layout">
            <validated-text-input
              class="md-layout-item"
              v-model="policy.insurance_integrity_warranties.address"
              label="Address"
              :disabled="isDisabled"
              :required="generateRequire"
            />

            <validated-autocomplete-input
              label="Post Code"
              class="md-layout-item md-small-size-12.5 md-size-12.5"
              v-model="policy.insurance_integrity_warranties.post_code"
              :options="postCodeOptions"
              :disabled="isDisabled"
              displaylabel="postalcode"
              :required="generateRequire"
              @select="
                ($event) =>
                  (policy.insurance_integrity_warranties.post_code_id =
                    $event.id)
              "
            >
            </validated-autocomplete-input>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <loading-icon-text-button
            class="md-primary md-simple"
            @click="onCancel"
            >{{ isDisabled ? "Okay" : "Cancel" }}</loading-icon-text-button
          >
          <loading-icon-text-button
            v-if="!isDisabled"
            class="md-primary md-simple"
            @click="ongerate"
            icon="file_upload"
            :loading="loading"
            :class="{ disabled: invalid }"
          >
            Generate
          </loading-icon-text-button>
        </md-dialog-actions>
      </md-dialog>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import { applicationValidation } from "@/components/utils/validation";
import ValidatedDateInput from "../ValidatedInput/ValidatedDateInput.vue";
import ValidatedAutocompleteInput from "../ValidatedInput/ValidatedAutocompleteInput.vue";
export default {
  components: {
    ValidatedAutocompleteInput,
    LoadingIconTextButton,
    ...ValidatedInputs,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    insurance: {
      required: true,
      type: Object | Array,
    },
    application: {
      required: true,
      type: Object | Array,
    },
  },
  watch: {},
  data() {
    return {
      generateRequire: false,
      isSaving: false,
      isSubmitted: false,
      alert: false,
      alertMessage: "",
      resultMessage: "",
      productsData: [],
      selected_doucments: [],
      vehicleMakes: [],
      viheclesBody: [],
      vehicleModels: [],
      warrantyTypes: [],
      warrantyOptions: [],
      warrantyTerms: [],
      postCodeOptions: [],
      loading: false,
      invalid: false,
      policy: {
        insurance_integrity_warranties: {},
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("onCancel", value);
      },
    },
    isDisabled() {
      return this.policy.policy_number ? true : false;
    },
    ...mapGetters({
      applicationStatus: "application_status",
    }),
  },
  mounted() {
    this.policy = { ...this.insurance };
    this.getBodyVehicles();
    this.getPostCodes();
    this.getIntegrityProducts();
    this.getVehicleMakes();

    if (
      !this.policy.insurance_integrity_warranties ||
      !this.policy.insurance_integrity_warranties.address
    ) {
      this.policy.insurance_integrity_warranties.address =
        (this.application.applicants[0].addresses.current.address.unit || "") +
        " " +
        (this.application.applicants[0].addresses.current.address
          .street_number || "") +
        " " +
        (this.application.applicants[0].addresses.current.address.street_name ||
          "") +
        " " +
        (this.application.applicants[0].addresses.current.address.street_type ||
          "") +
        " " +
        (this.application.applicants[0].addresses.current.address.suburb ||
          "") +
        " " +
        (this.application.applicants[0].addresses.current.address.state || "") +
        " " +
        (this.application.applicants[0].addresses.current.address.post_code ||
          "");
    }

    if (
      !this.policy.insurance_integrity_warranties ||
      !this.policy.insurance_integrity_warranties.vehicle_reg_no
    ) {
      this.policy.insurance_integrity_warranties.vehicle_reg_no =
        this.application.loan.asset.vehicle.registration;
    }
  },
  methods: {
    ...filters,
    async postNewPolicy() {
      try {
        //save the application
        await this.$store.dispatch("save_application", this.application);
        this.policy.first_name =
          this.application.applicants[0].contact.name.firstname;
        this.policy.last_name =
          this.application.applicants[0].contact.name.lastname;
        this.policy.phone =
          this.application.applicants[0].contact &&
          this.application.applicants[0].contact.phones
            ? this.application.applicants[0].contact.phones[0].phone_number
            : "";
        this.policy.process_type = "post_new_policy";
        const res = await axios
          .post(`/api/v1/processIntegrity`, this.policy)
          .then(async (res) => {
            //reload the application
            this.applicationStatus.dirty = false;
            await this.$store.dispatch("reload_application");
            this.onSucess();
            this.loading = false;
            this.alertMessage = "";
          })
          .catch((err) => {
            this.alert = true;
            this.alertMessage = err.response.data;
            this.loading = false;
          });
      } catch (e) {
        this.alert = true;
        this.alertMessage = err.response.data;
        this.loading = false;
      }
    },

    async getPostCodes() {
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "post_codes",
      });
      let postalData = res.data;

      if (
        this.application.applicants[0].addresses.current.address &&
        this.application.applicants[0].addresses.current.address.state
      ) {
        postalData = postalData.filter((data) => {
          return (
            data.state &&
            data.state.toLocaleLowerCase() ==
              this.application.applicants[0].addresses.current.address.state.toLocaleLowerCase()
          );
        });
      }

      if (
        this.application.applicants[0].addresses.current.address &&
        this.application.applicants[0].addresses.current.address.suburb
      ) {
        postalData = postalData.filter((data) => {
          return (
            data.suburb &&
            data.suburb.toLocaleLowerCase() ==
              this.application.applicants[0].addresses.current.address.suburb.toLocaleLowerCase()
          );
        });
      }

      if (this.application.applicants[0].addresses.current.address.post_code) {
        let selectedPostalcode = postalData.filter((data) => {
          return data.postalcode ==
            this.application.applicants[0].addresses.current.address.post_code;
        });

        if (selectedPostalcode.length > 0 && !this.policy.insurance_integrity_warranties.post_code_id) {
          this.policy.insurance_integrity_warranties.post_code =
            selectedPostalcode[0].postalcode;
          this.policy.insurance_integrity_warranties.post_code_id =
            selectedPostalcode[0].id;
        }
      }

      this.postCodeOptions = postalData;
    },
    async getBodyVehicles() {
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "vehicle_body_types",
      });
      this.viheclesBody = res.data;
    },
    async getIntegrityProducts() {
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "product",
      });
      this.productsData = res.data;
    },
    async warrentyTermsSelect($event) {
      this.policy.insurance_integrity_warranties.warranty_term_id = $event.id;
      //   policy.term_obj = $event;
    },
    productSelect($event) {
      this.policy.insurance_integrity_warranties.policy_id = $event.id;
      if (this.policy.insurance_integrity_warranties.vehicle_model_id) {
        this.getWarrantyTypes({
          id: this.policy.insurance_integrity_warranties.vehicle_model_id,
        });
      }
    },
    async getVehicleMakes() {
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "vehicle_makes",
      });

      this.vehicleMakes = res.data;

      if (
        this.application.loan.asset.vehicle.make &&
        !this.policy.insurance_integrity_warranties.vehicle_make_id
      ) {
        const filterData = this.vehicleMakes.filter((data) => {
          return (
            data.name.toLocaleLowerCase() ==
            this.application.loan.asset.vehicle.make.toLocaleLowerCase()
          );
        });

        if (filterData.length > 0 && !this.policy.insurance_integrity_warranties.vehicle_make_id) {
          this.policy.insurance_integrity_warranties.vehicle_make_id =
            filterData[0].id;
          this.policy.insurance_integrity_warranties.vehicle_make =
            filterData[0].name;
          this.getVehicleModels({
            id: this.policy.insurance_integrity_warranties.vehicle_make_id,
          });
        }
      }
    },
    async getWarrantyTerms($event) {
      if ($event.id) {
        this.policy.insurance_integrity_warranties.warranty_option_id =
          $event.id;
      }
      if (
        !this.policy.insurance_integrity_warranties.policy_id ||
        !this.policy.insurance_integrity_warranties.warranty_type ||
        !this.policy.insurance_integrity_warranties.warranty_option_id
      ) {
        return false;
      }
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "warranty_terms",
        productid: this.policy.insurance_integrity_warranties.policy_id,
        warrantytypename:
          this.policy.insurance_integrity_warranties.warranty_type,
        optionId: this.policy.insurance_integrity_warranties.warranty_option_id,
      });
      this.warrantyTerms = res.data;
    },
    async getWarrantyOptions($event) {
      if ($event.id) {
        this.policy.insurance_integrity_warranties.warranty_type_id = $event.id;
      }
      if (
        !this.policy.insurance_integrity_warranties.policy_id ||
        !this.policy.insurance_integrity_warranties.warranty_type
      ) {
        return false;
      }
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "warranty_options",
        productid: this.policy.insurance_integrity_warranties.policy_id,
        warrantytypename:
          this.policy.insurance_integrity_warranties.warranty_type,
      });
      this.warrantyOptions = res.data;
    },
    async getWarrantyTypes($event) {
      if ($event.id) {
        this.policy.insurance_integrity_warranties.vehicle_model_id = $event.id;
      }
      if (
        !this.policy.insurance_integrity_warranties.policy_id ||
        !this.policy.insurance_integrity_warranties.vehicle_make_id ||
        !this.policy.insurance_integrity_warranties.vehicle_model_id
      ) {
        return false;
      }
      const res = await axios.post(`/api/v1/processIntegrity`, {
        process_type: "warranty_types",
        productid: this.policy.insurance_integrity_warranties.policy_id,
        vehiclemakeid:
          this.policy.insurance_integrity_warranties.vehicle_make_id,
        VehicleModelId:
          this.policy.insurance_integrity_warranties.vehicle_model_id,
      });
      this.warrantyTypes = res.data;
    },
    async getVehicleModels($event) {
      if ($event.id) {
        this.policy.insurance_integrity_warranties.vehicle_make_id = $event.id;
        const res = await axios.post(`/api/v1/processIntegrity`, {
          process_type: "vehicle_models",
          vehiclemakeid: $event.id,
        });
        this.vehicleModels = res.data;

        if (
          this.application.loan.asset.vehicle.model &&
          !this.policy.insurance_integrity_warranties.vehicle_model_id
        ) {
          const filterData = this.vehicleModels.filter((data) => {
            return (
              data.name.toLocaleLowerCase() ==
              this.application.loan.asset.vehicle.model.toLocaleLowerCase()
            );
          });

          if (filterData.length > 0 && !this.policy.insurance_integrity_warranties.vehicle_model_id) {
            this.policy.insurance_integrity_warranties.vehicle_model_id =
              filterData[0].id;
            this.policy.insurance_integrity_warranties.vehicle_model =
              filterData[0].name;
            this.getWarrantyTypes({
              id: this.policy.insurance_integrity_warranties.vehicle_model_id,
            });
          }
        }
      }
    },
    onCancel() {
      this.isVisible = false;
    },
    onSucess() {
      this.$emit("onSucess");
      this.isVisible = false;
    },
    ongerate() {
      this.generateRequire = true;
      setTimeout(() => {
        this.validateGenretForm();
      }, 1000);
    },
    validateGenretForm() {
      return this.$refs.formGeneratePolicy.validate().then((res) => {
        if (res) {
          this.loading = true;
          this.postNewPolicy();
        } else {
          return false;
        }
      });
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>
<style scoped>
.upload_alert {
  border: 0;
  position: relative;
  padding: 20px 15px;
  line-height: 20px;
  margin-bottom: 20px;
  z-index: 99999 !important;
  background-color: #0b0e3c;
  color: #ffffff;
  border-radius: 3px;
  box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%),
    0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
}

.upload_error {
  border: 0;
  position: relative;
  padding: 20px 15px;
  line-height: 20px;
  margin-bottom: 20px;
  z-index: 99999 !important;
  background-color: #e31854;
  color: #ffffff;
  border-radius: 3px;
  box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%),
    0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
}
</style>
